export default __webpack_public_path__ + "static/media/banner-bg-previdencia.d72ac2a0.jpg";